// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { getProject, createProject, updateProject, uploadImages, uploadVideo, deleteFile } from '../utils/api';
// import toast from 'react-hot-toast';

// const CATS = ['2BHK', '3BHK', '4BHK', 'Penthouse', 'Villa', 'Commercial', 'Office', 'Retail', 'Industrial', 'Custom'];
// const STATUSES = ['Completed', 'Ongoing', 'Upcoming'];
// const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

// const initForm = {
//   title: '', shortDescription: '', description: '', category: '', location: '', area: '',
//   budget: '', completionDate: '', status: 'Completed', client: '', isFeatured: false,
//   isPublished: true, features: '', tags: '', metaTitle: '', metaDescription: '',
//   images: [], videos: []
// };

// export default function ProjectFormPage() {
//   const { id } = useParams();
//   const isEdit = Boolean(id);
//   const navigate = useNavigate();
//   const [form, setForm] = useState(initForm);
//   const [loading, setLoading] = useState(isEdit);
//   const [saving, setSaving] = useState(false);
//   const [imgUploading, setImgUploading] = useState(false);
//   const [imgProgress, setImgProgress] = useState(0);
//   const [vidUploading, setVidUploading] = useState(false);
//   const [vidProgress, setVidProgress] = useState(0);
//   const imgRef = useRef();
//   const vidRef = useRef();

//   useEffect(() => {
//     if (isEdit) {
//       getProject(id)
//         .then(r => {
//           const p = r.data.data;
//           setForm({
//             ...initForm, ...p,
//             features: (p.features || []).join('\n'),
//             tags: (p.tags || []).join(', '),
//             completionDate: p.completionDate ? p.completionDate.slice(0, 10) : '',
//             images: p.images || [],
//             videos: p.videos || []
//           });
//         })
//         .catch(() => toast.error('Failed to load project'))
//         .finally(() => setLoading(false));
//     }
//   }, [id, isEdit]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
//   };

//   const handleImageUpload = async (e) => {
//     const files = Array.from(e.target.files);
//     if (!files.length) return;
//     setImgUploading(true);
//     setImgProgress(0);
//     try {
//       const fd = new FormData();
//       files.forEach(f => fd.append('images', f));
//       const res = await uploadImages(fd, setImgProgress);
//       const newImgs = res.data.data.map(f => ({ url: f.url, caption: '', isThumbnail: false }));
//       setForm(p => ({
//         ...p,
//         images: [...p.images, ...newImgs].map((img, i) => ({ ...img, isThumbnail: i === 0 && p.images.length === 0 ? true : img.isThumbnail }))
//       }));
//       toast.success(`${files.length} image(s) uploaded`);
//     } catch { toast.error('Image upload failed'); }
//     finally { setImgUploading(false); imgRef.current.value = ''; }
//   };

//   const handleVideoUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setVidUploading(true);
//     setVidProgress(0);
//     try {
//       const fd = new FormData();
//       fd.append('video', file);
//       const res = await uploadVideo(fd, setVidProgress);
//       setForm(p => ({ ...p, videos: [...p.videos, { url: res.data.data.url, title: file.name.replace(/\.[^.]+$/, '') }] }));
//       toast.success('Video uploaded');
//     } catch { toast.error('Video upload failed'); }
//     finally { setVidUploading(false); vidRef.current.value = ''; }
//   };

//   const removeImage = async (idx) => {
//     const img = form.images[idx];
//     try { await deleteFile({ filePath: img.url }); } catch {}
//     setForm(p => {
//       const imgs = p.images.filter((_, i) => i !== idx);
//       if (imgs.length > 0 && !imgs.some(i => i.isThumbnail)) imgs[0].isThumbnail = true;
//       return { ...p, images: imgs };
//     });
//   };

//   const removeVideo = async (idx) => {
//     const vid = form.videos[idx];
//     try { await deleteFile({ filePath: vid.url }); } catch {}
//     setForm(p => ({ ...p, videos: p.videos.filter((_, i) => i !== idx) }));
//   };

//   const setThumbnail = (idx) => {
//     setForm(p => ({ ...p, images: p.images.map((img, i) => ({ ...img, isThumbnail: i === idx })) }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.title || !form.description || !form.category || !form.location) {
//       toast.error('Fill in all required fields'); return;
//     }
//     setSaving(true);
//     try {
//       const payload = {
//         ...form,
//         features: form.features ? form.features.split('\n').map(s => s.trim()).filter(Boolean) : [],
//         tags: form.tags ? form.tags.split(',').map(s => s.trim()).filter(Boolean) : [],
//       };
//       if (isEdit) await updateProject(id, payload);
//       else await createProject(payload);
//       toast.success(isEdit ? 'Project updated!' : 'Project created!');
//       navigate('/projects');
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Save failed');
//     } finally { setSaving(false); }
//   };

//   if (loading) return (
//     <div className="flex items-center justify-center py-20">
//       <div className="w-8 h-8 border-2 border-brand-400 border-t-transparent rounded-full animate-spin" />
//     </div>
//   );

//   const getImgUrl = (url) => url.startsWith('http') ? url : `${API_BASE}${url}`;

//   return (
//     <form onSubmit={handleSubmit} className="space-y-6 max-w-4xl">
//       {/* Header */}
//       <div className="flex items-center justify-between gap-4">
//         <div>
//           <h1 className="font-display text-xl font-semibold text-surface-100">{isEdit ? 'Edit Project' : 'Add New Project'}</h1>
//           <p className="text-surface-500 text-sm mt-0.5">{isEdit ? 'Update project details and media' : 'Fill in the details for your new project'}</p>
//         </div>
//         <div className="flex gap-3">
//           <button type="button" onClick={() => navigate('/projects')} className="btn-secondary">Cancel</button>
//           <button type="submit" disabled={saving} className="btn-primary">{saving ? 'Saving…' : isEdit ? 'Update Project' : 'Create Project'}</button>
//         </div>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Main fields */}
//         <div className="lg:col-span-2 space-y-5">
//           {/* Basic info */}
//           <div className="card p-5 space-y-4">
//             <h2 className="text-surface-300 font-medium text-sm border-b border-surface-700 pb-3">Basic Information</h2>
//             <div>
//               <label className="label">Project Title *</label>
//               <input name="title" value={form.title} onChange={handleChange} className="input" placeholder="e.g. Modern 3BHK – Prahlad Nagar" required />
//             </div>
//             <div>
//               <label className="label">Short Description</label>
//               <input name="shortDescription" value={form.shortDescription} onChange={handleChange} className="input" placeholder="One-line summary (shown in cards)" />
//             </div>
//             <div>
//               <label className="label">Full Description *</label>
//               <textarea name="description" value={form.description} onChange={handleChange} className="input min-h-[120px] resize-y"
//                 placeholder="Detailed project description…" required />
//             </div>
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="label">Location *</label>
//                 <input name="location" value={form.location} onChange={handleChange} className="input" placeholder="Ahmedabad, Gujarat" required />
//               </div>
//               <div>
//                 <label className="label">Area / Size</label>
//                 <input name="area" value={form.area} onChange={handleChange} className="input" placeholder="e.g. 1200 sq.ft." />
//               </div>
//             </div>
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="label">Budget Range</label>
//                 <input name="budget" value={form.budget} onChange={handleChange} className="input" placeholder="e.g. ₹15-20 Lakhs" />
//               </div>
//               <div>
//                 <label className="label">Client Name</label>
//                 <input name="client" value={form.client} onChange={handleChange} className="input" placeholder="Optional" />
//               </div>
//             </div>
//             <div>
//               <label className="label">Key Features (one per line)</label>
//               <textarea name="features" value={form.features} onChange={handleChange} className="input resize-y"
//                 rows={4} placeholder={"Custom wardrobe design\nItalian marble flooring\nSmart home integration"} />
//             </div>
//             <div>
//               <label className="label">Tags (comma separated)</label>
//               <input name="tags" value={form.tags} onChange={handleChange} className="input" placeholder="modern, minimal, luxury" />
//             </div>
//           </div>

//           {/* SEO */}
//           <div className="card p-5 space-y-4">
//             <h2 className="text-surface-300 font-medium text-sm border-b border-surface-700 pb-3">SEO (optional)</h2>
//             <div>
//               <label className="label">Meta Title</label>
//               <input name="metaTitle" value={form.metaTitle} onChange={handleChange} className="input" placeholder="Leave blank to use project title" />
//             </div>
//             <div>
//               <label className="label">Meta Description</label>
//               <textarea name="metaDescription" value={form.metaDescription} onChange={handleChange} className="input resize-none" rows={2} />
//             </div>
//           </div>

//           {/* Images */}
//           <div className="card p-5 space-y-4">
//             <h2 className="text-surface-300 font-medium text-sm border-b border-surface-700 pb-3">Project Images</h2>
//             <div>
//               <input ref={imgRef} type="file" accept="image/*" multiple onChange={handleImageUpload} className="hidden" />
//               <button type="button" onClick={() => imgRef.current.click()} disabled={imgUploading}
//                 className="btn-secondary w-full py-8 border-2 border-dashed border-surface-600 hover:border-brand-400 transition-colors text-sm disabled:opacity-60">
//                 {imgUploading ? `Uploading… ${imgProgress}%` : '+ Click to upload images (multiple allowed)'}
//               </button>
//               {imgUploading && (
//                 <div className="mt-2 h-1.5 bg-surface-700 rounded-full overflow-hidden">
//                   <div className="h-full bg-brand-400 transition-all duration-300" style={{ width: `${imgProgress}%` }} />
//                 </div>
//               )}
//             </div>
//             {form.images.length > 0 && (
//               <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
//                 {form.images.map((img, i) => (
//                   <div key={i} className={`relative group aspect-square rounded overflow-hidden border-2 cursor-pointer ${img.isThumbnail ? 'border-brand-400' : 'border-surface-700 hover:border-surface-500'}`}
//                     onClick={() => setThumbnail(i)}>
//                     <img src={getImgUrl(img.url)} alt="" className="w-full h-full object-cover"
//                       onError={e => { e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect fill="%2321262d" width="100" height="100"/></svg>'; }} />
//                     {img.isThumbnail && (
//                       <div className="absolute top-1 left-1 bg-brand-400 text-surface-900 text-[9px] font-bold px-1.5 py-0.5 rounded">THUMB</div>
//                     )}
//                     <button type="button" onClick={(e) => { e.stopPropagation(); removeImage(i); }}
//                       className="absolute top-1 right-1 bg-red-600 text-white w-5 h-5 rounded flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity">✕</button>
//                   </div>
//                 ))}
//               </div>
//             )}
//             <p className="text-surface-600 text-xs">Click an image to set as thumbnail. Hover to delete.</p>
//           </div>

//           {/* Videos */}
//           <div className="card p-5 space-y-4">
//             <h2 className="text-surface-300 font-medium text-sm border-b border-surface-700 pb-3">Project Videos</h2>
//             <div>
//               <input ref={vidRef} type="file" accept="video/*" onChange={handleVideoUpload} className="hidden" />
//               <button type="button" onClick={() => vidRef.current.click()} disabled={vidUploading}
//                 className="btn-secondary w-full py-6 border-2 border-dashed border-surface-600 hover:border-brand-400 transition-colors text-sm disabled:opacity-60">
//                 {vidUploading ? `Uploading… ${vidProgress}%` : '+ Upload Video (MP4, MOV, etc.)'}
//               </button>
//               {vidUploading && (
//                 <div className="mt-2 h-1.5 bg-surface-700 rounded-full overflow-hidden">
//                   <div className="h-full bg-brand-400 transition-all duration-300" style={{ width: `${vidProgress}%` }} />
//                 </div>
//               )}
//             </div>
//             {form.videos.map((vid, i) => (
//               <div key={i} className="flex items-center gap-3 bg-surface-700/50 rounded p-3">
//                 <span className="text-2xl">▶</span>
//                 <input value={vid.title} onChange={e => setForm(p => ({ ...p, videos: p.videos.map((v, j) => j === i ? { ...v, title: e.target.value } : v) }))}
//                   className="input flex-1 py-1.5 text-sm" placeholder="Video title" />
//                 <button type="button" onClick={() => removeVideo(i)} className="text-red-400 hover:text-red-300 text-sm transition-colors flex-shrink-0">✕</button>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Right sidebar */}
//         <div className="space-y-5">
//           {/* Publish settings */}
//           <div className="card p-5 space-y-4">
//             <h2 className="text-surface-300 font-medium text-sm border-b border-surface-700 pb-3">Settings</h2>
//             <div>
//               <label className="label">Category *</label>
//               <select name="category" value={form.category} onChange={handleChange} className="input" required>
//                 <option value="">Select category</option>
//                 {CATS.map(c => <option key={c} value={c}>{c}</option>)}
//               </select>
//             </div>
//             <div>
//               <label className="label">Status</label>
//               <select name="status" value={form.status} onChange={handleChange} className="input">
//                 {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
//               </select>
//             </div>
//             <div>
//               <label className="label">Completion Date</label>
//               <input type="date" name="completionDate" value={form.completionDate} onChange={handleChange} className="input" />
//             </div>
//             <div className="flex items-center gap-3 py-2">
//               <input type="checkbox" id="isPublished" name="isPublished" checked={form.isPublished} onChange={handleChange} className="accent-brand-400 w-4 h-4" />
//               <label htmlFor="isPublished" className="text-surface-300 text-sm cursor-pointer">Published (visible on website)</label>
//             </div>
//             <div className="flex items-center gap-3 py-2">
//               <input type="checkbox" id="isFeatured" name="isFeatured" checked={form.isFeatured} onChange={handleChange} className="accent-brand-400 w-4 h-4" />
//               <label htmlFor="isFeatured" className="text-surface-300 text-sm cursor-pointer">Featured (show on homepage)</label>
//             </div>
//           </div>

//           {/* Submit */}
//           <div className="card p-5 space-y-3">
//             <button type="submit" disabled={saving} className="btn-primary w-full py-2.5">
//               {saving ? 'Saving…' : isEdit ? '✓ Update Project' : '+ Create Project'}
//             </button>
//             <button type="button" onClick={() => navigate('/projects')} className="btn-secondary w-full py-2.5">
//               Cancel
//             </button>
//           </div>
//         </div>
//       </div>
//     </form>
//   );
// }


// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams, Link } from 'react-router-dom';
// import { ArrowLeft, Save, Loader, Upload } from 'lucide-react';
// import { createProject, updateProject, getAdminCategories } from '../utils/api';
// import toast from 'react-hot-toast';

// const PROJECT_TYPES = ['2BHK', '3BHK', 'Commercial', 'Custom', 'Villa', 'Penthouse'];
// const STATUSES = ['ongoing', 'completed', 'upcoming'];

// const initial = {
//   title: '', short_description: '', description: '', project_type: '2BHK',
//   location: '', category_id: '', completion_date: '', area_sqft: '',
//   client_name: '', budget: '', status: 'completed',
//   is_featured: false, is_active: true,
//   meta_title: '', meta_description: '',
// };

// export default function ProjectFormPage() {
//   const { id } = useParams();
//   const isEdit = !!id;
//   const navigate = useNavigate();

//   const [form, setForm] = useState(initial);
//   const [categories, setCategories] = useState([]);
//   const [thumbnail, setThumbnail] = useState(null);
//   const [thumbnailPreview, setThumbnailPreview] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     getAdminCategories().then(r => setCategories(r.data.data || []));
//     // If editing, fetch project data here (simplified - in production use a getProject endpoint)
//   }, [id]);

//   const validate = () => {
//     const errs = {};
//     if (!form.title.trim()) errs.title = 'Title is required';
//     if (!form.short_description.trim()) errs.short_description = 'Short description is required';
//     if (!form.description.trim()) errs.description = 'Description is required';
//     if (!form.location.trim()) errs.location = 'Location is required';
//     return errs;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const errs = validate();
//     if (Object.keys(errs).length) { setErrors(errs); toast.error('Please fix the errors'); return; }

//     setLoading(true);
//     try {
//       const fd = new FormData();
//       // Append all form fields
//       Object.entries(form).forEach(([k, v]) => {
//         if (v !== '' && v !== null && v !== undefined) {
//           fd.append(k, v === true ? '1' : v === false ? '0' : v);
//         }
//       });
//       if (thumbnail) fd.append('thumbnail', thumbnail);
//       // Laravel needs _method for PUT via FormData
//       if (isEdit) fd.append('_method', 'PUT');

//       if (isEdit) {
//         await updateProject(id, fd);
//         toast.success('Project updated successfully!');
//       } else {
//         await createProject(fd);
//         toast.success('Project created successfully!');
//       }
//       navigate('/projects');
//     } catch (err) {
//       const errs = err.response?.data?.errors;
//       if (errs) {
//         setErrors(errs);
//         toast.error('Please fix validation errors');
//       } else {
//         toast.error(err.response?.data?.message || 'Something went wrong');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
//     if (errors[name]) setErrors(errs => ({ ...errs, [name]: '' }));
//   };

//   const handleThumbnail = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (file.size > 5 * 1024 * 1024) { toast.error('Image must be under 5MB'); return; }
//     setThumbnail(file);
//     setThumbnailPreview(URL.createObjectURL(file));
//   };

//   // const Field = ({ name, label, required, children, error }) => (
//   //   <div>
//   //     <label className="label">{label}{required && <span className="text-red-400 ml-0.5">*</span>}</label>
//   //     {children}
//   //     {(error || errors[name]) && <p className="text-red-400 text-xs mt-1">{error || errors[name]}</p>}
//   //   </div>
//   // );


//   const Field = ({ name, label, required, children, error, errors }) => (
//   <div>
//     <label className="label">
//       {label}
//       {required && <span className="text-red-400 ml-0.5">*</span>}
//     </label>
//     {children}
//     {(error || errors?.[name]) && (
//       <p className="text-red-400 text-xs mt-1">
//         {error || errors?.[name]}
//       </p>
//     )}
//   </div>
// );


//   return (
//     <div className="max-w-4xl">
//       <div className="flex items-center gap-3 mb-6">
//         <Link to="/projects" className="btn-ghost p-2"><ArrowLeft size={16} /></Link>
//         <div>
//           <h1 className="text-xl font-semibold text-white">{isEdit ? 'Edit Project' : 'New Project'}</h1>
//           <p className="text-white/40 text-sm">{isEdit ? 'Update project information' : 'Create a new portfolio project'}</p>
//         </div>
//       </div>

//       <form onSubmit={handleSubmit} className="space-y-4">
//         {/* Basic Info */}
//         <div className="card p-5">
//           <h2 className="font-medium text-white mb-4 text-sm">Basic Information</h2>
//           <div className="space-y-4">
//             <Field name="title" label="Project Title" required>
//               <input name="title" value={form.title} onChange={handleChange} placeholder="e.g. Modern 3BHK Apartment" className={`input ${errors.title ? 'border-red-500/50' : ''}`} />
//             </Field>

//             <Field name="short_description" label="Short Description" required>
//               <textarea name="short_description" value={form.short_description} onChange={handleChange} rows={2} placeholder="Brief summary shown in listings..." className={`input resize-none ${errors.short_description ? 'border-red-500/50' : ''}`} />
//             </Field>

//             <Field name="description" label="Full Description" required>
//               <textarea name="description" value={form.description} onChange={handleChange} rows={8} placeholder="Detailed project description..." className={`input resize-none ${errors.description ? 'border-red-500/50' : ''}`} />
//             </Field>
//           </div>
//         </div>

//         {/* Project Details */}
//         <div className="card p-5">
//           <h2 className="font-medium text-white mb-4 text-sm">Project Details</h2>
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//             <Field name="project_type" label="Project Type" required>
//               <select name="project_type" value={form.project_type} onChange={handleChange} className="input">
//                 {PROJECT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
//               </select>
//             </Field>

//             <Field name="category_id" label="Category">
//               <select name="category_id" value={form.category_id} onChange={handleChange} className="input">
//                 <option value="">Select category</option>
//                 {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
//               </select>
//             </Field>

//             <Field name="location" label="Location" required>
//               <input name="location" value={form.location} onChange={handleChange} placeholder="City, State" className={`input ${errors.location ? 'border-red-500/50' : ''}`} />
//             </Field>

//             <Field name="status" label="Status">
//               <select name="status" value={form.status} onChange={handleChange} className="input">
//                 {STATUSES.map(s => <option key={s} value={s} className="capitalize">{s}</option>)}
//               </select>
//             </Field>

//             <Field name="completion_date" label="Completion Date">
//               <input type="date" name="completion_date" value={form.completion_date} onChange={handleChange} className="input" />
//             </Field>

//             <Field name="area_sqft" label="Area (sq.ft)">
//               <input type="number" name="area_sqft" value={form.area_sqft} onChange={handleChange} placeholder="1200" className="input" />
//             </Field>

//             <Field name="client_name" label="Client Name">
//               <input name="client_name" value={form.client_name} onChange={handleChange} placeholder="Client name" className="input" />
//             </Field>

//             <Field name="budget" label="Budget (₹)">
//               <input type="number" name="budget" value={form.budget} onChange={handleChange} placeholder="2500000" className="input" />
//             </Field>
//           </div>

//           <div className="flex items-center gap-6 mt-4">
//             <label className="flex items-center gap-2 cursor-pointer">
//               <input type="checkbox" name="is_featured" checked={form.is_featured} onChange={handleChange} className="w-4 h-4 accent-primary-500 rounded" />
//               <span className="text-sm text-white/70">Featured Project</span>
//             </label>
//             <label className="flex items-center gap-2 cursor-pointer">
//               <input type="checkbox" name="is_active" checked={form.is_active} onChange={handleChange} className="w-4 h-4 accent-primary-500 rounded" />
//               <span className="text-sm text-white/70">Active (Visible on website)</span>
//             </label>
//           </div>
//         </div>

//         {/* Thumbnail */}
//         <div className="card p-5">
//           <h2 className="font-medium text-white mb-4 text-sm">Thumbnail Image</h2>
//           <div className="flex items-start gap-4">
//             <div className="w-32 h-24 bg-surface-700 rounded-lg overflow-hidden shrink-0 border border-white/10">
//               {thumbnailPreview ? (
//                 <img src={thumbnailPreview} alt="Preview" className="w-full h-full object-cover" />
//               ) : (
//                 <div className="w-full h-full flex items-center justify-center text-white/20 text-xs">No image</div>
//               )}
//             </div>
//             <div>
//               <label className="btn-secondary cursor-pointer">
//                 <Upload size={14} /> Choose Image
//                 <input type="file" accept="image/*" onChange={handleThumbnail} className="hidden" />
//               </label>
//               <p className="text-white/30 text-xs mt-2">Max 5MB. JPG, PNG, WebP supported.</p>
//             </div>
//           </div>
//         </div>

//         {/* SEO */}
//         <div className="card p-5">
//           <h2 className="font-medium text-white mb-4 text-sm">SEO Settings</h2>
//           <div className="space-y-3">
//             <Field name="meta_title" label="Meta Title">
//               <input name="meta_title" value={form.meta_title} onChange={handleChange} placeholder="SEO title (defaults to project title)" className="input" />
//             </Field>
//             <Field name="meta_description" label="Meta Description">
//               <textarea name="meta_description" value={form.meta_description} onChange={handleChange} rows={2} placeholder="SEO description..." className="input resize-none" />
//             </Field>
//           </div>
//         </div>

//         {/* Actions */}
//         <div className="flex items-center gap-3">
//           <button type="submit" disabled={loading} className="btn-primary">
//             {loading ? <><Loader size={14} className="animate-spin" /> Saving...</> : <><Save size={14} /> {isEdit ? 'Update Project' : 'Create Project'}</>}
//           </button>
//           <Link to="/projects" className="btn-secondary">Cancel</Link>
//         </div>
//       </form>
//     </div>
//   );
// }


// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams, Link } from 'react-router-dom';
// import { ArrowLeft, Save, Loader, Upload, X, CheckCircle2, Info } from 'lucide-react';
// import { createProject, updateProject, getAdminCategories, getProject } from '../utils/api';
// import toast from 'react-hot-toast';

// const PROJECT_TYPES = ['2BHK', '3BHK', 'Commercial', 'Custom', 'Villa', 'Penthouse'];
// const STATUSES = ['ongoing', 'completed', 'upcoming'];

// const initial = {
//   title: '', short_description: '', description: '', project_type: '2BHK',
//   location: '', category_id: '', completion_date: '', area_sqft: '',
//   client_name: '', budget: '', status: 'completed',
//   is_featured: false, is_active: true,
//   meta_title: '', meta_description: '',
// };

// // Fixed Field component — errors prop passed explicitly
// const Field = ({ name, label, required, hint, errors = {}, children }) => (
//   <div className="space-y-1.5">
//     <div className="flex items-center justify-between">
//       <label className="text-sm font-medium text-white/70">
//         {label}
//         {required && <span className="text-red-400 ml-0.5">*</span>}
//       </label>
//       {hint && <span className="text-white/25 text-xs">{hint}</span>}
//     </div>
//     {children}
//     {errors[name] && (
//       <p className="flex items-center gap-1.5 text-red-400 text-xs mt-1">
//         <span className="w-1 h-1 rounded-full bg-red-400 shrink-0" />
//         {errors[name]}
//       </p>
//     )}
//   </div>
// );

// // Shared input class builder
// const inputCls = (hasError) =>
//   `w-full bg-white/5 border ${hasError ? 'border-red-500/50 focus:border-red-500' : 'border-white/10 focus:border-violet-500/60'} text-white text-sm placeholder:text-white/25 rounded-xl px-4 py-2.5 focus:outline-none focus:bg-white/8 transition-all`;

// export default function ProjectFormPage() {
//   const { id } = useParams();
//   const isEdit = !!id;
//   const navigate = useNavigate();

//   const [form, setForm] = useState(initial);
//   const [categories, setCategories] = useState([]);
//   const [thumbnail, setThumbnail] = useState(null);
//   const [thumbnailPreview, setThumbnailPreview] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [fetching, setFetching] = useState(isEdit);
//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     getAdminCategories().then(r => setCategories(r.data.data || []));

//     if (isEdit) {
//       setFetching(true);
//       getProject(id)
//         .then(r => {
//           const p = r.data.data;
//           setForm({
//             title: p.title || '',
//             short_description: p.short_description || '',
//             description: p.description || '',
//             project_type: p.project_type || '2BHK',
//             location: p.location || '',
//             category_id: p.category_id || '',
//             completion_date: p.completion_date || '',
//             area_sqft: p.area_sqft || '',
//             client_name: p.client_name || '',
//             budget: p.budget || '',
//             status: p.status || 'completed',
//             is_featured: !!p.is_featured,
//             is_active: p.is_active !== undefined ? !!p.is_active : true,
//             meta_title: p.meta_title || '',
//             meta_description: p.meta_description || '',
//           });
//           if (p.thumbnail_url) setThumbnailPreview(p.thumbnail_url);
//         })
//         .catch(() => toast.error('Failed to load project'))
//         .finally(() => setFetching(false));
//     }
//   }, [id]);

//   const validate = () => {
//     const errs = {};
//     if (!form.title.trim()) errs.title = 'Title is required';
//     if (!form.short_description.trim()) errs.short_description = 'Short description is required';
//     if (!form.description.trim()) errs.description = 'Description is required';
//     if (!form.location.trim()) errs.location = 'Location is required';
//     return errs;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const errs = validate();
//     if (Object.keys(errs).length) {
//       setErrors(errs);
//       toast.error('Please fix the highlighted fields');
//       return;
//     }

//     setLoading(true);
//     try {
//       const fd = new FormData();
//       Object.entries(form).forEach(([k, v]) => {
//         if (v !== '' && v !== null && v !== undefined) {
//           fd.append(k, v === true ? '1' : v === false ? '0' : v);
//         }
//       });
//       if (thumbnail) fd.append('thumbnail', thumbnail);
//       if (isEdit) fd.append('_method', 'PUT');

//       if (isEdit) {
//         await updateProject(id, fd);
//         toast.success('Project updated successfully!');
//       } else {
//         await createProject(fd);
//         toast.success('Project created successfully!');
//       }
//       navigate('/projects');
//     } catch (err) {
//       const serverErrors = err.response?.data?.errors;
//       if (serverErrors) {
//         setErrors(serverErrors);
//         toast.error('Please fix validation errors');
//       } else {
//         toast.error(err.response?.data?.message || 'Something went wrong');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
//     if (errors[name]) setErrors(errs => ({ ...errs, [name]: '' }));
//   };

//   const handleThumbnail = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (file.size > 5 * 1024 * 1024) { toast.error('Image must be under 5MB'); return; }
//     setThumbnail(file);
//     const url = URL.createObjectURL(file);
//     setThumbnailPreview(url);
//   };

//   const removeThumbnail = () => {
//     setThumbnail(null);
//     setThumbnailPreview('');
//   };

//   if (fetching) {
//     return (
//       <div className="max-w-4xl">
//         <div className="flex items-center gap-3 mb-8">
//           <div className="w-10 h-10 rounded-xl bg-white/5 animate-pulse" />
//           <div className="space-y-2">
//             <div className="h-4 w-32 bg-white/5 rounded-full animate-pulse" />
//             <div className="h-3 w-48 bg-white/5 rounded-full animate-pulse" />
//           </div>
//         </div>
//         {[...Array(3)].map((_, i) => (
//           <div key={i} className="rounded-2xl border border-white/8 bg-white/3 p-6 mb-4 animate-pulse">
//             <div className="h-4 w-40 bg-white/5 rounded-full mb-5" />
//             <div className="space-y-3">
//               <div className="h-10 bg-white/5 rounded-xl" />
//               <div className="h-10 bg-white/5 rounded-xl" />
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-4xl">
//       {/* Header */}
//       <div className="flex items-center gap-4 mb-8">
//         <Link
//           to="/projects"
//           className="w-10 h-10 flex items-center justify-center rounded-xl text-white/40 hover:text-white hover:bg-white/8 border border-white/8 hover:border-white/15 transition-all"
//         >
//           <ArrowLeft size={17} />
//         </Link>
//         <div>
//           <h1 className="text-2xl font-bold text-white tracking-tight">
//             {isEdit ? 'Edit Project' : 'New Project'}
//           </h1>
//           <p className="text-white/40 text-sm mt-0.5">
//             {isEdit ? 'Update project information and settings' : 'Add a new project to your portfolio'}
//           </p>
//         </div>
//       </div>

//       <form onSubmit={handleSubmit} className="space-y-4">

//         {/* Basic Information */}
//         <Section title="Basic Information" icon="📝">
//           <div className="space-y-5">
//             <Field name="title" label="Project Title" required errors={errors}>
//               <input
//                 name="title"
//                 value={form.title}
//                 onChange={handleChange}
//                 placeholder="e.g. Modern 3BHK Apartment in South Mumbai"
//                 className={inputCls(errors.title)}
//               />
//             </Field>

//             <Field name="short_description" label="Short Description" required hint={`${form.short_description.length}/160`} errors={errors}>
//               <textarea
//                 name="short_description"
//                 value={form.short_description}
//                 onChange={handleChange}
//                 rows={2}
//                 maxLength={160}
//                 placeholder="Brief summary shown in project listings and cards..."
//                 className={`${inputCls(errors.short_description)} resize-none`}
//               />
//             </Field>

//             <Field name="description" label="Full Description" required errors={errors}>
//               <textarea
//                 name="description"
//                 value={form.description}
//                 onChange={handleChange}
//                 rows={7}
//                 placeholder="Detailed project description — design philosophy, materials used, challenges overcome..."
//                 className={`${inputCls(errors.description)} resize-none`}
//               />
//             </Field>
//           </div>
//         </Section>

//         {/* Project Details */}
//         <Section title="Project Details" icon="🏗️">
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
//             <Field name="project_type" label="Project Type" errors={errors}>
//               <select name="project_type" value={form.project_type} onChange={handleChange} className={inputCls(false)}>
//                 {PROJECT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
//               </select>
//             </Field>

//             <Field name="category_id" label="Category" errors={errors}>
//               <select name="category_id" value={form.category_id} onChange={handleChange} className={inputCls(false)}>
//                 <option value="">Select category</option>
//                 {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
//               </select>
//             </Field>

//             <Field name="location" label="Location" required errors={errors}>
//               <input
//                 name="location"
//                 value={form.location}
//                 onChange={handleChange}
//                 placeholder="e.g. Bandra West, Mumbai"
//                 className={inputCls(errors.location)}
//               />
//             </Field>

//             <Field name="status" label="Status" errors={errors}>
//               <select name="status" value={form.status} onChange={handleChange} className={inputCls(false)}>
//                 {STATUSES.map(s => (
//                   <option key={s} value={s} className="capitalize">{s.charAt(0).toUpperCase() + s.slice(1)}</option>
//                 ))}
//               </select>
//             </Field>

//             <Field name="completion_date" label="Completion Date" errors={errors}>
//               <input
//                 type="date"
//                 name="completion_date"
//                 value={form.completion_date}
//                 onChange={handleChange}
//                 className={inputCls(false)}
//               />
//             </Field>

//             <Field name="area_sqft" label="Area (sq.ft)" errors={errors}>
//               <input
//                 type="number"
//                 name="area_sqft"
//                 value={form.area_sqft}
//                 onChange={handleChange}
//                 placeholder="e.g. 1200"
//                 min="0"
//                 className={inputCls(false)}
//               />
//             </Field>

//             <Field name="client_name" label="Client Name" errors={errors}>
//               <input
//                 name="client_name"
//                 value={form.client_name}
//                 onChange={handleChange}
//                 placeholder="Client or company name"
//                 className={inputCls(false)}
//               />
//             </Field>

//             <Field name="budget" label="Budget (₹)" errors={errors}>
//               <input
//                 type="number"
//                 name="budget"
//                 value={form.budget}
//                 onChange={handleChange}
//                 placeholder="e.g. 2500000"
//                 min="0"
//                 className={inputCls(false)}
//               />
//             </Field>
//           </div>

//           {/* Toggles */}
//           <div className="flex flex-wrap items-center gap-4 mt-6 pt-5 border-t border-white/8">
//             <Toggle
//               name="is_featured"
//               checked={form.is_featured}
//               onChange={handleChange}
//               label="Featured Project"
//               description="Show in featured section"
//             />
//             <Toggle
//               name="is_active"
//               checked={form.is_active}
//               onChange={handleChange}
//               label="Active"
//               description="Visible on the website"
//             />
//           </div>
//         </Section>

//         {/* Thumbnail */}
//         <Section title="Thumbnail Image" icon="🖼️">
//           {thumbnailPreview ? (
//             <div className="flex items-start gap-5">
//               <div className="relative w-40 h-28 rounded-xl overflow-hidden border border-white/10 shrink-0">
//                 <img src={thumbnailPreview} alt="Thumbnail preview" className="w-full h-full object-cover" />
//                 <button
//                   type="button"
//                   onClick={removeThumbnail}
//                   className="absolute top-1.5 right-1.5 w-6 h-6 flex items-center justify-center bg-black/60 backdrop-blur rounded-full text-white/80 hover:text-white hover:bg-black/80 transition-all"
//                 >
//                   <X size={11} />
//                 </button>
//               </div>
//               <div>
//                 <p className="text-white/60 text-sm font-medium mb-1">
//                   {thumbnail ? thumbnail.name : 'Current thumbnail'}
//                 </p>
//                 {thumbnail && (
//                   <p className="text-white/30 text-xs">{(thumbnail.size / 1024).toFixed(0)} KB</p>
//                 )}
//                 <label className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/8 hover:bg-white/12 border border-white/10 text-white/60 hover:text-white text-xs font-medium cursor-pointer transition-all">
//                   <Upload size={12} /> Change Image
//                   <input type="file" accept="image/*" onChange={handleThumbnail} className="hidden" />
//                 </label>
//               </div>
//             </div>
//           ) : (
//             <label className="flex flex-col items-center justify-center gap-3 p-8 rounded-xl border-2 border-dashed border-white/10 hover:border-violet-500/40 hover:bg-violet-500/5 cursor-pointer transition-all group">
//               <div className="w-12 h-12 rounded-xl bg-white/5 group-hover:bg-violet-500/10 flex items-center justify-center transition-colors">
//                 <Upload size={20} className="text-white/25 group-hover:text-violet-400 transition-colors" />
//               </div>
//               <div className="text-center">
//                 <p className="text-white/50 text-sm font-medium">Click to upload thumbnail</p>
//                 <p className="text-white/25 text-xs mt-0.5">JPG, PNG, WebP · Max 5MB</p>
//               </div>
//               <input type="file" accept="image/*" onChange={handleThumbnail} className="hidden" />
//             </label>
//           )}
//         </Section>

//         {/* SEO */}
//         <Section title="SEO Settings" icon="🔍">
//           <div className="space-y-4">
//             <Field name="meta_title" label="Meta Title" hint="Defaults to project title if empty" errors={errors}>
//               <input
//                 name="meta_title"
//                 value={form.meta_title}
//                 onChange={handleChange}
//                 placeholder="Custom SEO title for search engines"
//                 className={inputCls(false)}
//               />
//             </Field>
//             <Field name="meta_description" label="Meta Description" hint={`${form.meta_description.length}/160`} errors={errors}>
//               <textarea
//                 name="meta_description"
//                 value={form.meta_description}
//                 onChange={handleChange}
//                 rows={2}
//                 maxLength={160}
//                 placeholder="Short SEO description shown in search results..."
//                 className={`${inputCls(false)} resize-none`}
//               />
//             </Field>
//           </div>
//         </Section>

//         {/* Submit */}
//         <div className="flex items-center gap-3 pt-1 pb-8">
//           <button
//             type="submit"
//             disabled={loading}
//             className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-violet-500 to-indigo-500 hover:from-violet-400 hover:to-indigo-400 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-xl transition-all shadow-lg shadow-violet-500/20 hover:shadow-violet-500/30 hover:-translate-y-0.5 disabled:translate-y-0"
//           >
//             {loading
//               ? <><Loader size={14} className="animate-spin" /> Saving...</>
//               : <><Save size={14} /> {isEdit ? 'Update Project' : 'Create Project'}</>
//             }
//           </button>
//           <Link
//             to="/projects"
//             className="px-4 py-2.5 rounded-xl text-white/50 hover:text-white hover:bg-white/8 border border-white/8 hover:border-white/15 text-sm font-medium transition-all"
//           >
//             Cancel
//           </Link>
//         </div>
//       </form>
//     </div>
//   );
// }

// // Section wrapper
// function Section({ title, icon, children }) {
//   return (
//     <div className="rounded-2xl border border-white/8 bg-white/3 p-6">
//       <h2 className="flex items-center gap-2 text-sm font-semibold text-white/80 mb-5">
//         <span>{icon}</span> {title}
//       </h2>
//       {children}
//     </div>
//   );
// }

// // Toggle component
// function Toggle({ name, checked, onChange, label, description }) {
//   return (
//     <label className="flex items-center gap-3 cursor-pointer group">
//       <div className={`relative w-10 h-5.5 rounded-full transition-all duration-200 ${checked ? 'bg-violet-500' : 'bg-white/10'}`}>
//         <input type="checkbox" name={name} checked={checked} onChange={onChange} className="sr-only" />
//         <div className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform duration-200 ${checked ? 'translate-x-4.5' : 'translate-x-0'}`} />
//       </div>
//       <div>
//         <p className="text-sm text-white/70 font-medium group-hover:text-white/90 transition-colors">{label}</p>
//         <p className="text-xs text-white/30">{description}</p>
//       </div>
//     </label>
//   );
// }



import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { ArrowLeft, Save, Loader, Upload, X } from 'lucide-react';
import { createProject, updateProject, getAdminCategories, getProject } from '../utils/api';
import toast from 'react-hot-toast';

const PROJECT_TYPES = ['2BHK', '3BHK', 'Commercial', 'Custom', 'Villa', 'Penthouse'];
const STATUSES = ['ongoing', 'completed', 'upcoming'];

const initial = {
  title: '', short_description: '', description: '', project_type: '2BHK',
  location: '', category_id: '', completion_date: '', area_sqft: '',
  client_name: '', budget: '', status: 'completed',
  is_featured: false, is_active: true,
  meta_title: '', meta_description: '',
};

/* ─── Keyframes injected once ─── */
const STYLES = `
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes sectionIn {
    from { opacity: 0; transform: translateY(12px) scale(0.99); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes headerPop {
    from { opacity: 0; transform: translateX(-12px); }
    to   { opacity: 1; transform: translateX(0); }
  }
`;

/* ─── Field wrapper ─── */
const Field = ({ name, label, required, hint, errors = {}, children }) => (
  <div className="space-y-1.5">
    <div className="flex items-center justify-between">
      <label className="text-sm font-medium text-white/70">
        {label}
        {required && <span className="text-red-400 ml-0.5">*</span>}
      </label>
      {hint && <span className="text-white/25 text-xs">{hint}</span>}
    </div>
    {children}
    {errors[name] && (
      <p className="flex items-center gap-1.5 text-red-400 text-xs mt-1">
        <span className="w-1 h-1 rounded-full bg-red-400 shrink-0" />
        {errors[name]}
      </p>
    )}
  </div>
);

const inputCls = (hasError) =>
  `w-full bg-white/5 border ${hasError
    ? 'border-red-500/50 focus:border-red-500'
    : 'border-white/10 focus:border-primary-500/60'
  } text-white text-sm placeholder:text-white/25 rounded-xl px-4 py-2.5 focus:outline-none focus:bg-white/8 transition-all`;

/* ─── Section wrapper with stagger animation ─── */
function Section({ title, icon, children, delay = 0 }) {
  return (
    <div
      className="rounded-2xl border border-white/8 bg-white/3 p-6"
      style={{
        animation: `sectionIn 0.45s cubic-bezier(0.22,1,0.36,1) both`,
        animationDelay: `${delay}ms`,
      }}
    >
      <h2 className="flex items-center gap-2 text-sm font-semibold text-white/80 mb-5">
        <span>{icon}</span> {title}
      </h2>
      {children}
    </div>
  );
}

/* ─── FIXED Toggle — uses inline styles so thumb always moves ─── */
function Toggle({ name, checked, onChange, label, description }) {
  return (
    <label className="flex items-center gap-3 cursor-pointer group select-none">
      {/* Track */}
      <div
        style={{
          position: 'relative',
          width: 40,
          height: 22,
          borderRadius: 11,
          flexShrink: 0,
          background: checked ? '#dc7b28' : 'rgba(255,255,255,0.1)',
          border: checked ? '1px solid rgba(220,123,40,0.4)' : '1px solid rgba(255,255,255,0.12)',
          transition: 'background 0.22s ease, border-color 0.22s ease',
          cursor: 'pointer',
        }}
      >
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
        />
        {/* Thumb */}
        <div
          style={{
            position: 'absolute',
            top: 2,
            left: checked ? 18 : 2,
            width: 16,
            height: 16,
            borderRadius: '50%',
            background: checked ? '#fff' : 'rgba(255,255,255,0.6)',
            boxShadow: '0 1px 4px rgba(0,0,0,0.35)',
            transition: 'left 0.22s cubic-bezier(0.34,1.56,0.64,1), background 0.22s ease',
          }}
        />
      </div>

      {/* Labels */}
      <div>
        <p className="text-sm font-medium text-white/70 group-hover:text-white/90 transition-colors leading-tight">
          {label}
        </p>
        <p className="text-xs text-white/30 mt-0.5">{description}</p>
      </div>

      {/* Active badge */}
      {checked && (
        <span
          style={{
            fontSize: 10,
            padding: '2px 7px',
            borderRadius: 20,
            background: 'rgba(220,123,40,0.12)',
            color: '#dc7b28',
            fontWeight: 600,
            letterSpacing: '0.03em',
            animation: 'fadeSlideUp 0.2s ease both',
          }}
        >
          ON
        </span>
      )}
    </label>
  );
}

export default function ProjectFormPage() {
  const { id } = useParams();
  const isEdit = !!id;
  const navigate = useNavigate();

  const [form, setForm] = useState(initial);
  const [categories, setCategories] = useState([]);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(isEdit);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getAdminCategories().then(r => setCategories(r.data.data || []));
    if (isEdit) {
      setFetching(true);
      getProject(id)
        .then(r => {
          const p = r.data.data;
          setForm({
            title:             p.title || '',
            short_description: p.short_description || '',
            description:       p.description || '',
            project_type:      p.project_type || '2BHK',
            location:          p.location || '',
            category_id:       p.category_id || '',
            completion_date:   p.completion_date || '',
            area_sqft:         p.area_sqft || '',
            client_name:       p.client_name || '',
            budget:            p.budget || '',
            status:            p.status || 'completed',
            is_featured:       !!p.is_featured,
            is_active:         p.is_active !== undefined ? !!p.is_active : true,
            meta_title:        p.meta_title || '',
            meta_description:  p.meta_description || '',
          });
          if (p.thumbnail_url) setThumbnailPreview(p.thumbnail_url);
        })
        .catch(() => toast.error('Failed to load project'))
        .finally(() => setFetching(false));
    }
  }, [id]);

  const validate = () => {
    const errs = {};
    if (!form.title.trim())             errs.title = 'Title is required';
    if (!form.short_description.trim()) errs.short_description = 'Short description is required';
    if (!form.description.trim())       errs.description = 'Description is required';
    if (!form.location.trim())          errs.location = 'Location is required';
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      toast.error('Please fix the highlighted fields');
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => {
        // Always send booleans, skip only truly empty strings
        if (typeof v === 'boolean') {
          fd.append(k, v ? '1' : '0');
        } else if (v !== '' && v !== null && v !== undefined) {
          fd.append(k, v);
        }
      });
      if (thumbnail) fd.append('thumbnail', thumbnail);
      if (isEdit) fd.append('_method', 'PUT');

      if (isEdit) {
        await updateProject(id, fd);
        toast.success('Project updated successfully!');
      } else {
        await createProject(fd);
        toast.success('Project created successfully!');
      }
      navigate('/projects');
    } catch (err) {
      const serverErrors = err.response?.data?.errors;
      if (serverErrors) {
        setErrors(serverErrors);
        toast.error('Please fix validation errors');
      } else {
        toast.error(err.response?.data?.message || 'Something went wrong');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors(errs => ({ ...errs, [name]: '' }));
  };

  const handleThumbnail = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error('Image must be under 5MB'); return; }
    setThumbnail(file);
    setThumbnailPreview(URL.createObjectURL(file));
  };

  const removeThumbnail = () => { setThumbnail(null); setThumbnailPreview(''); };

  /* ── Fetching skeleton ── */
  if (fetching) {
    return (
      <div className="max-w-4xl">
        <style>{STYLES}</style>
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-white/5 animate-pulse" />
          <div className="space-y-2">
            <div className="h-4 w-32 bg-white/5 rounded-full animate-pulse" />
            <div className="h-3 w-48 bg-white/5 rounded-full animate-pulse" />
          </div>
        </div>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="rounded-2xl border border-white/8 bg-white/3 p-6 mb-4 animate-pulse">
            <div className="h-4 w-40 bg-white/5 rounded-full mb-5" />
            <div className="space-y-3">
              <div className="h-10 bg-white/5 rounded-xl" />
              <div className="h-10 bg-white/5 rounded-xl" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="max-w-4xl">
      <style>{STYLES}</style>

      {/* Header */}
      <div
        className="flex items-center gap-4 mb-8"
        style={{ animation: 'headerPop 0.4s cubic-bezier(0.22,1,0.36,1) both' }}
      >
        <Link
          to="/projects"
          className="w-10 h-10 flex items-center justify-center rounded-xl text-white/40 hover:text-white hover:bg-white/8 border border-white/8 hover:border-white/15 transition-all"
        >
          <ArrowLeft size={17} />
        </Link>
        <div>
          <h1 className="text-2xl font-bold text-white tracking-tight">
            {isEdit ? 'Edit Project' : 'New Project'}
          </h1>
          <p className="text-white/40 text-sm mt-0.5">
            {isEdit ? 'Update project information and settings' : 'Add a new project to your portfolio'}
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Basic Information */}
        <Section title="Basic Information" icon="📝" delay={60}>
          <div className="space-y-5">
            <Field name="title" label="Project Title" required errors={errors}>
              <input
                name="title" value={form.title} onChange={handleChange}
                placeholder="e.g. Modern 3BHK Apartment in South Mumbai"
                className={inputCls(errors.title)}
              />
            </Field>
            <Field name="short_description" label="Short Description" required hint={`${form.short_description.length}/160`} errors={errors}>
              <textarea
                name="short_description" value={form.short_description} onChange={handleChange}
                rows={2} maxLength={160}
                placeholder="Brief summary shown in project listings and cards..."
                className={`${inputCls(errors.short_description)} resize-none`}
              />
            </Field>
            <Field name="description" label="Full Description" required errors={errors}>
              <textarea
                name="description" value={form.description} onChange={handleChange}
                rows={7}
                placeholder="Detailed project description — design philosophy, materials used, challenges overcome..."
                className={`${inputCls(errors.description)} resize-none`}
              />
            </Field>
          </div>
        </Section>

        {/* Project Details */}
        <Section title="Project Details" icon="🏗️" delay={120}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <Field name="project_type" label="Project Type" errors={errors}>
              <select name="project_type" value={form.project_type} onChange={handleChange} className={inputCls(false)}>
                {PROJECT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </Field>
            <Field name="category_id" label="Category" errors={errors}>
              <select name="category_id" value={form.category_id} onChange={handleChange} className={inputCls(false)}>
                <option value="">Select category</option>
                {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </Field>
            <Field name="location" label="Location" required errors={errors}>
              <input name="location" value={form.location} onChange={handleChange}
                placeholder="e.g. Bandra West, Mumbai" className={inputCls(errors.location)} />
            </Field>
            <Field name="status" label="Status" errors={errors}>
              <select name="status" value={form.status} onChange={handleChange} className={inputCls(false)}>
                {STATUSES.map(s => (
                  <option key={s} value={s} className="capitalize">{s.charAt(0).toUpperCase() + s.slice(1)}</option>
                ))}
              </select>
            </Field>
            <Field name="completion_date" label="Completion Date" errors={errors}>
              <input type="date" name="completion_date" value={form.completion_date}
                onChange={handleChange} className={inputCls(false)} />
            </Field>
            <Field name="area_sqft" label="Area (sq.ft)" errors={errors}>
              <input type="number" name="area_sqft" value={form.area_sqft}
                onChange={handleChange} placeholder="e.g. 1200" min="0" className={inputCls(false)} />
            </Field>
            <Field name="client_name" label="Client Name" errors={errors}>
              <input name="client_name" value={form.client_name}
                onChange={handleChange} placeholder="Client or company name" className={inputCls(false)} />
            </Field>
            <Field name="budget" label="Budget (₹)" errors={errors}>
              <input type="number" name="budget" value={form.budget}
                onChange={handleChange} placeholder="e.g. 2500000" min="0" className={inputCls(false)} />
            </Field>
          </div>

          {/* Toggles */}
          <div className="flex flex-wrap items-center gap-6 mt-6 pt-5 border-t border-white/8">
            <Toggle
              name="is_featured"
              checked={form.is_featured}
              onChange={handleChange}
              label="Featured Project"
              description="Show in featured section"
            />
            <Toggle
              name="is_active"
              checked={form.is_active}
              onChange={handleChange}
              label="Active"
              description="Visible on the website"
            />
          </div>
        </Section>

        {/* Thumbnail */}
        <Section title="Thumbnail Image" icon="🖼️" delay={180}>
          {thumbnailPreview ? (
            <div className="flex items-start gap-5">
              <div className="relative w-40 h-28 rounded-xl overflow-hidden border border-white/10 shrink-0">
                <img src={thumbnailPreview} alt="Thumbnail preview" className="w-full h-full object-cover" />
                <button
                  type="button" onClick={removeThumbnail}
                  className="absolute top-1.5 right-1.5 w-6 h-6 flex items-center justify-center bg-black/60 backdrop-blur rounded-full text-white/80 hover:text-white hover:bg-black/80 transition-all"
                >
                  <X size={11} />
                </button>
              </div>
              <div>
                <p className="text-white/60 text-sm font-medium mb-1">
                  {thumbnail ? thumbnail.name : 'Current thumbnail'}
                </p>
                {thumbnail && <p className="text-white/30 text-xs">{(thumbnail.size / 1024).toFixed(0)} KB</p>}
                <label className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/8 hover:bg-white/12 border border-white/10 text-white/60 hover:text-white text-xs font-medium cursor-pointer transition-all">
                  <Upload size={12} /> Change Image
                  <input type="file" accept="image/*" onChange={handleThumbnail} className="hidden" />
                </label>
              </div>
            </div>
          ) : (
            <label className="flex flex-col items-center justify-center gap-3 p-8 rounded-xl border-2 border-dashed border-white/10 hover:border-primary-500/40 hover:bg-primary-500/5 cursor-pointer transition-all group">
              <div className="w-12 h-12 rounded-xl bg-white/5 group-hover:bg-primary-500/10 flex items-center justify-center transition-colors">
                <Upload size={20} className="text-white/25 group-hover:text-primary-400 transition-colors" />
              </div>
              <div className="text-center">
                <p className="text-white/50 text-sm font-medium">Click to upload thumbnail</p>
                <p className="text-white/25 text-xs mt-0.5">JPG, PNG, WebP · Max 5MB</p>
              </div>
              <input type="file" accept="image/*" onChange={handleThumbnail} className="hidden" />
            </label>
          )}
        </Section>

        {/* SEO */}
        <Section title="SEO Settings" icon="🔍" delay={240}>
          <div className="space-y-4">
            <Field name="meta_title" label="Meta Title" hint="Defaults to project title if empty" errors={errors}>
              <input name="meta_title" value={form.meta_title} onChange={handleChange}
                placeholder="Custom SEO title for search engines" className={inputCls(false)} />
            </Field>
            <Field name="meta_description" label="Meta Description" hint={`${form.meta_description.length}/160`} errors={errors}>
              <textarea
                name="meta_description" value={form.meta_description} onChange={handleChange}
                rows={2} maxLength={160}
                placeholder="Short SEO description shown in search results..."
                className={`${inputCls(false)} resize-none`}
              />
            </Field>
          </div>
        </Section>

        {/* Submit */}
        <div
          className="flex items-center gap-3 pt-1 pb-8"
          style={{ animation: 'fadeSlideUp 0.4s ease both', animationDelay: '300ms' }}
        >
          <button
            type="submit"
            disabled={loading}
            className="flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-400 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-xl transition-all shadow-lg shadow-primary-500/20 hover:shadow-primary-500/30 hover:-translate-y-0.5 disabled:translate-y-0"
          >
            {loading
              ? <><Loader size={14} className="animate-spin" /> Saving...</>
              : <><Save size={14} /> {isEdit ? 'Update Project' : 'Create Project'}</>
            }
          </button>
          <Link
            to="/projects"
            className="px-4 py-2.5 rounded-xl text-white/50 hover:text-white hover:bg-white/8 border border-white/8 hover:border-white/15 text-sm font-medium transition-all"
          >
            Cancel
          </Link>
        </div>
      </form>
    </div>
  );
}